import Change from './Change';

export default class Sticky {
  constructor(element) {
    this.element = element;
    this.register();
    this.update();
  }

  register() {
    Change.onChange(this.update.bind(this));
  }

  update() {
    this.element.classList[this.state]('sticky');
  }

  get offset() {
    return this.element.parentNode.offsetTop;
  }

  get state() {
    return window.innerHeight - this.offset > this.element.offsetHeight ? 'add' : 'remove';
  }
}
